export function formatPlaca(placa?: string | null): string {
  if (!placa) return '';
  const clean = placa.replace(/[^A-Z0-9]/gi, '').toUpperCase();
  if (clean.length === 7) return `${clean.slice(0, 3)}-${clean.slice(3)}`;
  if (clean.length === 8) return clean;
  return clean;
}
